import { render, staticRenderFns } from "./CompanyShopAddresses.vue?vue&type=template&id=04ee339f&"
import script from "./CompanyShopAddresses.vue?vue&type=script&lang=js&"
export * from "./CompanyShopAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/CompanyShopAddresses.vue
// module id = null
// module chunks = 